import { Link } from "react-router-dom";

import { Box, Button, Stack, Typography } from "@mui/material";
import RestrictedSvg from "../assets/403.svg";

export const Forbidden = () => (
  <Stack
    sx={{
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <Box component="img" src={RestrictedSvg} sx={{
      height: "40%"
    }} />
    <Typography variant="h4" sx={{ mt: 10 }}>
      Hak akses terbatas
    </Typography>
    <Typography color="text.secondary" sx={{ mt: 1 }}>
      Anda tidak memiliki izin untuk membuka halaman ini. Hubungi admin jika
      Anda merasa seharusnya bisa mengaksesnya.
    </Typography>
    <Button component={Link} to="/dashboard" sx={{ mt: 2 }}>
      Kembali ke Dashboard
    </Button>
  </Stack>
);
